export const sanatiseUrl = (url) => {
    return url.replace(/-/g, ' ');
};